import React, { Fragment } from "react";
import { useIdleTimer } from "react-idle-timer";
const DEFAULT_TIMEOUT = 1000 * 60;
const DEFAULT_DEBOUNCE = 500;

const IdleTimer = ({
  timeout = DEFAULT_TIMEOUT,
  debounce = DEFAULT_DEBOUNCE,
  onIdle,
  onActive,
  onAction,
}) => {
  const handleOnIdle = (event) => {
    onIdle && onIdle(event, getLastActiveTime());
  };

  const handleOnActive = (event) => {
    onActive && onActive(event, getRemainingTime());
  };

  const handleOnAction = (event) => {
    onAction && onAction(event);
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: timeout,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: debounce,
  });
  /**
   * @TODO
   * for the time being use as a empty react component but later need to change it as a hook
   */
  return <Fragment></Fragment>;
};

export default IdleTimer;
